import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PayAccountForm from '../forms/PayAccountForm'
import globals from '../globals'
import DataSource from '../DataSource'

class PayAccount extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            failedAmount: 0,
            failedReason: '',
            failedDate: ''
        }
    }

    componentDidMount () {
        this.getData()
    }

    handleFailure (response, state) {
        const stateClone = Object.assign({}, state)
        stateClone.credit_card_number = new Array(stateClone.credit_card_number.length + 1).join('*')
        stateClone.credit_card_cvc = new Array(stateClone.credit_card_cvc.length + 1).join('*')
    }

    getData () {
        DataSource.getData('/api/getFailedAmountOwing', response => {
            this.setState({
                failedAmount: response.amount,
                failedReason: response.reason,
                failedDate: response.date,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        const Balance = () => {
            if (this.state.failedAmount > 0) {
                return (
                    <React.Fragment>
                        <p className='bold'>Failed payment notice</p>
                        <p>On <span className='bold'>{this.state.failedDate}</span> your financial institution declined your Exetel payment of <span className='bold'>${this.state.failedAmount}</span> for the following reason:<br /><span className='bold'>{this.state.failedReason}</span>.</p>
                        <p>If you are making a payment to re-activate your service, please allow 30 minutes for your service to switch on.</p>
                    </React.Fragment>
                )
            }

            return <p>Your current amount due is <span className='bold'>${this.props.accountBalance}</span>.</p>
        }

        return (
            <div className='pay-account module' style={{ overflow: 'visible' }}>
                <Heading title='Pay my account now' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError}>
                    <div className='row p-4'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>
                                You can make a payment at any time via credit or debit card on your Exetel account here.
                                Once you’ve made a payment, we’ll send you a confirmation email straight away, a new invoice will be posted on your "View Invoices" tab within the hour, and the Amount Due shown on your “Account summary” tab will update overnight.
                                <br /><br />
                                If you need to update the details of the credit / debit card or bank account attached to your account you’ll need to click on the “Update payment method” tab.
                            </p>
                            {Balance()}
                        </div>
                        <div className='col-12 col-md-6 offset-md-3'>
                            <PayAccountForm
                                accountBalance={this.props.accountBalance}
                                failedAmount={this.state.failedAmount}
                                handleSuccess={() => globals.pushEvent('PayAccountSubmit')}
                                handleFailure={this.handleFailure.bind(this)}
                            />
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default PayAccount



// WEBPACK FOOTER //
// ./resources/js/modules/PayAccount.js